import FullPageLoader from "@Components/FullPageLoader";
import loadable from "@loadable/component";
import ErrorBoundary from "@Components/ErrorBoundary";
import AmberCopilotWrapper from "@Components/Chatbot/AmberCopilotWrapper";

const BookFromSuccessWrapper = loadable(() => import("./BookFromSuccessWrapper"), {
  fallback: <FullPageLoader />,
});

export default (props: any): JSX.Element => (
  <ErrorBoundary>
    <BookFromSuccessWrapper {...props} />
    <AmberCopilotWrapper />
  </ErrorBoundary>
);
